<template>
  <div>
      <Banner v-bind:bannerMessage="bannerMessage" />

      <div class="mt-5 mr-5 ml-5 pt-3 pb-3 pr-5 pl-5 d-none d-sm-none d-md-block d-lg-none d-xl-none">
        <Message v-bind:notification="notification" />
      </div>

      <div class="container">

        <div v-if="linkRewardsMsg" class="mb-5 pb-4 d-block d-sm-block d-md-none d-lg-block d-xl-block">
          <Message v-bind:notification="notification" />
        </div>

        <div v-if="linkRewardsErrorMsg" class="mb-5 pb-4 d-none d-sm-none d-md-none d-lg-block d-xl-block">
          <ErrorMessage v-bind:errorNotification="errorNotification" />
        </div>

        <div class="row">

          <div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 col-right-padding">
            <h1 class="title pb-3 pb-lg-0 mb-3 mb-lg-5">Not a member? Join today.</h1>

            <img class="icon mt-1 mr-3" src="@/assets/checkmark.svg"><p class="text mb-2">Access exclusive discount days</p>
            <img class="icon mt-1 mr-3" src="@/assets/checkmark.svg"><p class="text mb-2">Earn Rewards points on purchases</p>
            <img class="icon mt-1 mr-3" src="@/assets/checkmark.svg"><p class="text pb-3 pb-lg-0 mb-3 mb-lg-5">Spend Rewards points in-store</p>

            <div v-if="upgradeNoCardErrorMsg" class="d-block d-sm-block d-md-block d-lg-none d-xl-none">
              <ErrorMessage class="mb-4 mb-lg-5" v-bind:errorNotification="errorNotification" />
            </div>

            <button v-if="isMyBeauty" v-on:click="upgradeNoCard" type="submit" class="btn btn-primary green-btn">Join Harrods Rewards & MyBeauty</button>
            <button v-else v-on:click="upgradeNoCard" type="submit" class="btn btn-primary green-btn">Join Harrods Rewards</button>

            <AgreementUnsubscription class="custom-text-agreement-and-unsubscription" />
          </div>

          <div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 col-right-padding">
            <h2 class="title pb-3 pb-lg-0 mb-3 mb-lg-5">Already have a Harrods Rewards card?</h2>

            <p class="text pb-3 pb-lg-0 mb-3 mb-lg-5">If you are an existing Harrods Rewards member, enter your card number below to link your Rewards card to your online account.</p>

            <div v-if="upgradeWithCardErrorMsg" class="d-block d-sm-block d-md-block d-lg-none d-xl-none">
              <ErrorMessage class="mb-4 mb-lg-5" v-bind:errorNotification="errorNotification" />
            </div>

            <label class="label mb-1">Harrods Rewards card number</label>
            <input class="form-control input-field pl-4" type="text" v-model.trim.lazy="rewardsNumber" v-bind:class="{ 'error-box' : v$.value.rewardsNumber.$dirty && !v$.value.rewardsNumber.sixteenDigits}" placeholder="Enter your 16 digit Rewards card number">
            <div class="error-text" v-if="v$.value.rewardsNumber.$dirty">
                <p class="mt-1 mb-3 mb-lg-4" v-if="!v$.value.rewardsNumber.sixteenDigits">Rewards Number must be a 16 digit number</p>
            </div>

            <router-link :to="`/en-gb${isMyBeauty ? '/mybeauty' : ''}/retrieve-card-number`" target="_blank"><p class="hyperlink pt-3 pb-3 pb-lg-0 mb-3 mb-lg-5">Don’t know your card number?</p></router-link>

            
            <button v-on:click="upgradeWithCard" type="submit" class="btn btn-primary gold-btn">
                <div v-if="showLoader" class="spinner-border white-spinner" role="status" aria-label="Spinning">
                    <span class="visually-hidden">Loading...</span>
                </div>
              <div v-if="!showLoader">Link Rewards Card</div>
            </button>
          </div>

        </div>
      </div>
  </div>
</template>

<script setup>
    import { ref, computed, watch } from 'vue'
    import { useRoute, useRouter } from 'vue-router'
    import Banner from '@/components/Banner.vue'
    import Message from '@/components/Message.vue'
    import ErrorMessage from '@/components/ErrorMessage.vue'
    import integrationApi from '@/services/IntegrationApiClient.js'
    import useVuelidate from '@vuelidate/core'
    import { required, helpers } from '@vuelidate/validators'

    const rewardsNumber = ref('')
    const rules = {
        rewardsNumber: {
            sixteenDigits: value => value === '' || value.length === 16
        }
    }
    const v$ = useVuelidate(rules, { rewardsNumber })
    // Props
    defineProps({
        showVerifiedMessage: Boolean,
        showVerifiedErrorMessage: Boolean,
        showPasswordResetMessage: Boolean
    })

    // Router
    const route = useRoute()
    const router = useRouter()

    // State
    const bannerMessage = ref('Your Rewards card is waiting')
    const registerMsg = ref('')
    const notification = ref("To download your digital Rewards card, it's best to sign in on a mobile device.")
    const errorVerifiedMsg = ref("Sorry, we haven't been able confirm whether you account is verified. <br />If you believe you have verified, please continue to sign-in")
    const verifiedMsg = ref("Your account has been verified successfully")
    const errorNotification = ref('')
    const passwordResetMsg = ref("Your password has been successfully reset. Please login with your new password.")
    const LoginMsg = ref(true)
    const LoginErrorMsg = ref(false)
    const source = ref(route.query.l || '')
    const email = ref('')
    const marketingOptIn = ref(false)

    // isMyBeauty logic (update as needed for your app)
    const isMyBeauty = computed(() => {
        // If you have a global property, use inject or provide/inject pattern
        // Here, fallback to route param or query
        return route.params.isMyBeauty === 'mybeauty' || route.query.isMyBeauty === 'true' || route.query.isMyBeauty === true
    })

    // Methods
    function displayLoginErrorMsg(errorMsg) {
        LoginMsg.value = false
        LoginErrorMsg.value = true
        errorNotification.value = errorMsg
    }

    function goToGetRegister() {
        router.push({
            name: 'GetRewardsRegister',
            params: {
                source: source.value,
                email: email.value,
                setPageTitle: "Register your Rewards card",
                doesUserHaveRewards: true,
                marketingOptIn: marketingOptIn.value,
                isMyBeauty: isMyBeauty.value
            }
        })
    }

    function goToJoinRegister() {
        router.push({
            name: 'JoinRewardsRegister',
            params: {
                source: source.value,
                email: email.value,
                marketingOptIn: marketingOptIn.value,
                isMyBeauty: isMyBeauty.value
            }
        })
    }

    function decryptPurplePayload() {
        if (route.query.u !== undefined) {
            integrationApi.decryptVal(route.query.u).then(result => {
                email.value = result.email
                marketingOptIn.value = result.optedIn === true
            })
        }
    }

    // Lifecycle
    registerMsg.value = isMyBeauty.value ? 'Join Harrods Rewards & MyBeauty' : 'Join Harrods Rewards'
    decryptPurplePayload()

    // If route can change while component is alive, watch for changes
    watch(() => route.query.u, (newU) => {
        if (newU !== undefined) {
            decryptPurplePayload()
        }
    })
</script>
<style lang="scss" scoped>

.title {
    @media screen and (max-width: 991px) and (min-width: 0px) {
        font-size: 24px;
    }

    @media screen and (min-width: 992px) {
        font-size: 30px;
    }
}

.custom-text-agreement-and-unsubscription p {
  font-size: 14px;
  font-weight: 400;
}

.container {
  background-color: $harrods-white;

  @media screen and (max-width: 1199px) and (min-width: 992px) {
      padding-right: 50px;
      padding-left: 50px;
  }

  @media screen and (min-width: 1200px) {
      padding-right: 75px;
      padding-left: 75px;
  }
}

.col-right-padding {
  @media screen and (max-width: 1199px) and (min-width: 992px) {
      padding-right: 70px;
  }
}

</style>
